module.exports = __webpack_public_path__ + "static/media/seLayer.0f393675.png";